<template>
  <div id="produceReportPrint">
    <div
      v-for="(ele,idx) in sliceDataList"
      :key="idx"
      :class="idx+1 !== sliceDataList.length ? 'break_after' : ''"
    >
      <el-row type="flex" justify="center" style="position:relative">
        <img
          src="../assets/lyLogo.jpg"
          style="position:absolute;left:4cm;width:80px;height:80px;top:0"
        />
        <h1 style="margin-bottom:0.8cm;margin-top:0.5cm;font-size:1cm">生产日报表</h1>
      </el-row>
      <el-row style="margin-bottom:0.1cm;font-size:0.4cm" type="flex" justify="space-around">
        <span>生产单位：{{dataList[0].department}}</span>
        <span></span>
        <span>日期：{{dataList[0].produce_date}}</span>
      </el-row>
      <table>
        <tr>
          <td>序号</td>
          <td>操作员</td>
          <td>产品名称</td>
          <td>产品规格</td>
          <td>加工步骤</td>
          <td>作业时间</td>
          <td>实际产量</td>
          <td>备注</td>
        </tr>
        <tr v-for="index in 15" :key="index">
          <td>{{index}}</td>
          <td
            v-if="ele[index-1] !== undefined"
          >{{!ele[index-2] ? ele[index-1].operator : ele[index-2].operator === ele[index-1].operator ? '' : ele[index-1].operator}}</td>
          <td v-else></td>
          <td v-if="ele[index-1] !== undefined">{{ele[index-1].product_name}}</td>
          <td v-else></td>
          <td v-if="ele[index-1] !== undefined">{{ele[index-1].product_size}}</td>
          <td v-else></td>
          <td v-if="ele[index-1] !== undefined">{{ele[index-1].process}}</td>
          <td v-else></td>
          <td
            v-if="ele[index-1] !== undefined"
          >{{ele[index-1].produce_hour ? Math.round(ele[index-1].produce_hour)+'＂' : ''}}</td>
          <td v-else></td>
          <td
            v-if="ele[index-1] !== undefined"
          >{{isNaN(parseFloat(ele[index-1].produce_count)) ? '' :parseFloat(ele[index-1].produce_count)}}</td>
          <td v-else></td>
          <td class="remark" v-if="ele[index-1] !== undefined">{{ele[index-1].remark}}</td>
          <td v-else></td>
        </tr>
      </table>
      <el-row type="flex" justify="space-between" style="font-size:0.4cm">
        <span style="padding-left:0.5cm">填写人：</span>
        <span style="padding-right:2cm">组长：</span>
      </el-row>
    </div>
  </div>
</template>

<script>
import { sliceArray } from '../assets/lib/utils'
export default {
  data () {
    return {
      dataList: JSON.parse(this.$route.query.dataList),
      sliceDataList: []
    }
  },
  computed: {
    tableData: function () {
      var tableArr = []
      this.dataList.reduce((last, current, curIndex) => {
        if (curIndex === 1) {
          tableArr.push(last)
        }
        if (last.operator !== current.operator && tableArr.length % 15 !== 0) {
          tableArr.push(undefined)
        }
        tableArr.push(current)
        return current
      })
      return tableArr
    }
  },
  mounted () {
    this.sliceDataList = sliceArray(this.tableData, 15)
    setTimeout(() => {
      window.print()
    }, 500)
  }
}
</script>

<style>
#produceReportPrint table,
#produceReportPrint table tr th,
#produceReportPrint table tr td {
  border: 1px solid #000000;
  line-height: 20px;
}
#produceReportPrint table {
  text-align: center;
  border-collapse: collapse;
  width: 100%;
}
@media print {
  #produceReportPrint table {
    font-size: 0.4cm;
  }
  #produceReportPrint table .remark {
    font-size: 0.05cm;
  }
  #produceReportPrint img {
    width: 1.5cm;
    height: 1.5cm;
  }
  #produceReportPrint h1 {
    font-size: 1.3cm;
  }
  .break_after {
    page-break-after: always;
  }
}
@page :pseudo-class {
  size: A4;
}
</style>
